import {
  ApiResponse,
  CommonParams,
  CreateGroupDto,
  CreateMyGroupDto,
  GetGroupsRespDto,
  StoreGroupDto,
} from "@/types";
import { createQueryString } from "@/utils/filterParams";
import api from "./api";

export const storeGroupService = {
  getStoreGroup: async () => {
    const response = await api.get("/store-groups");
    return response.data;
  },

  createStoreGroup: async (
    data: CreateGroupDto
  ): Promise<ApiResponse<StoreGroupDto>> => {
    try {
      const response = await api.post("/store-groups", data);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },

  createMyStoreGroup: async (
    data: CreateMyGroupDto
  ): Promise<ApiResponse<StoreGroupDto>> => {
    try {
      const response = await api.post("/store-groups/my-company", data);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },

  updateStoreGroup: async (
    id: number,
    data: {
      name: string;
      storeIds: number[];
    }
  ) => {
    try {
      const response = await api.patch(`/store-groups/${id}`, data);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },

  getStoreGroupById: async (
    id: number
  ): Promise<ApiResponse<GetGroupsRespDto>> => {
    try {
      const response = await api.get(`/store-groups/${id}`);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },

  getStoreGroupInCompany: async (
    params: CommonParams<{ companyId: number }>
  ): Promise<ApiResponse<StoreGroupDto[]>> => {
    try {
      const paramsValue = {
        page: 1,
        isPagination: 0,
        limit: 100,
        orderBy: "id",
        order: "DESC",
        withDeleted: 0,
        ...params,
      };
      const paramsString = createQueryString(paramsValue);
      const response = await api.get(`/store-groups?${paramsString}`);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },
  getStoreGroupMyCompany: async (
    params: CommonParams<{}>
  ): Promise<ApiResponse<StoreGroupDto[]>> => {
    const response = await api.get(`/store-groups/my-company`, { params });
    return response.data;
  },

  getMyStoreGroup: async (
    params: CommonParams<{ companyId: number }>
  ): Promise<ApiResponse<StoreGroupDto[]>> => {
    try {
      const paramsValue = {
        page: 1,
        isPagination: 0,
        orderBy: "id",
        order: "DESC",
        withDeleted: 0,
        ...params,
      };
      const paramsString = createQueryString(paramsValue);
      const response = await api.get(
        `/store-groups/my-company?${paramsString}`
      );
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },

  getMyManagerStoreGroups: async (
    params: CommonParams<{ companyId: number }>
  ): Promise<ApiResponse<StoreGroupDto[]>> => {
    try {
      const paramsValue = {
        page: 1,
        isPagination: 0,
        orderBy: "id",
        order: "DESC",
        withDeleted: 0,
        ...params,
      };
      const paramsString = createQueryString(paramsValue);
      const response = await api.get(`/store-groups/my-group?${paramsString}`);
      return response.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },

  moveStoreGroup: async (data: {
    userId: number;
    groupId: number[];
  }): Promise<ApiResponse<null>> => {
    try {
      const response = await api.post(`/store-groups/move`, {
        user_id: data.userId,
        group_ids: data.groupId,
      });
      return response.data.data;
    } catch (error: any) {
      throw error.response.data;
    }
  },
};
